import React from "react";
import { CustomizedDialogWrapper } from "./CustomizedDialog.style";

interface ICustomizedDialog {
  open: boolean;
  handleCloseDialog: any;
  children: React.ReactNode;
}

const CustomizedDialog = ({
  open,
  handleCloseDialog,
  children,
}: ICustomizedDialog) => {
  return (
    <CustomizedDialogWrapper open={open} onClose={handleCloseDialog}>
      {children}
    </CustomizedDialogWrapper>
  );
};

export default CustomizedDialog;
